// A shared no-op, for default callback props, context defaults, and the like.
export const noop = (): void => {
  // intentionally empty
};
